import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  @Input() title: string;
  @Input() subtitle?: string;
  @Input() cancelLabel?: string;
  @Input() validateLabel?: string;
  @Output() cancel = new EventEmitter();
  @Output() validate = new EventEmitter();

  constructor(private bsModalRef: BsModalRef) {
    // do nothing
  }

  hideModal() {
    this.bsModalRef.hide();
  }
}
